/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { Input } from "@progress/kendo-react-inputs";

export default function FormInput({
  label,
  rules,
  name,
  isRequired,
  info,
  disabled,
  errors,
  control,
  inputProps,
  formControlProps,
  onBlur,
  onChange,
}) {
  return (
    <FormControl
      isRequired={Boolean(isRequired)}
      style={formControlProps ? { ...formControlProps } : {}}
    >
      <FormLabel>{label}</FormLabel>
      <Controller
        control={control}
        name={name}
        rules={rules || {}}
        render={({ field }) => {
          return (
            <Input
              {...inputProps}
              className={errors[name] ? "error-field" : ""}
              disabled={disabled}
              value={field.value || ""}
              onChange={(e) => {
                field.onChange(e.value);
                if (onChange) onChange(e.value);
              }}
              onBlur={(e) => {
                if (onBlur) onBlur(e);
              }}
            />
          );
        }}
      />
      {info ? (
        <p className="error-message" style={{ color: "black" }}>
          {info || ""}
        </p>
      ) : (
        <></>
      )}
      {errors ? (
        errors[name] ? (
          <p className="error-message">
            {errors[name].message || "Please Select Date!"}
          </p>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </FormControl>
  );
}
